module.exports = __webpack_public_path__ + "media/1x1/zw-8b885465.svg";